import React from 'react';
import { Formik } from 'formik';
import FormInput from '../../../general/form-input/form-input.component';
import Button from '../../../general/button/button.component';
import './formEligibility.styles.scss';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Padding from '../../../general/padding/Padding';
import db from '../../../../firebase.config';
import { collection, query, where, getDocs } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';

const finalList = []; //global variable for next page
let company; //global variable for next page
let CTC; //global variable for next page

const PersonalDetails = () => {

    const navigate = useNavigate();
    
    const dataRetriever = async (tenthper,twelfthper,UGCGPA) => {
      const allStudentsRef = collection(db, "studentData");
      const queriedResult1 = query(allStudentsRef, where("UGCGPA", ">=", (UGCGPA)));
      // const queriedResult2 = query(queriedResult1, where(where("twelfthper", ">=", (twelfthper))));
      // const queriedResult3 = query(queriedResult2, where(("UGCGPA", ">=", (UGCGPA))));
      const docsSnapshot = await getDocs(queriedResult1);
      console.log(docsSnapshot);
      docsSnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        if(doc.data().tenthper >= tenthper && doc.data().twelfthper >= twelfthper)
        finalList.push(doc.data());
      });
      console.log(finalList)
    };
    

  return (
  <div>
    <Formik
      initialValues={{ companyname: '', salary: '', tenthper: '', twelfthper: '', PGCGPA: '', UGCGPA: '', backlogs: '', educationgap: ''}}
      validate={values => {
        const errors = {};
        if (!values.companyname) {
          errors.companyname = 'Required';
        }
        if (!values.salary) {
          errors.salary = 'Required';
        }
        if (!values.tenthper) {
          errors.tenthper = 'Required';
        }
        if (!values.twelfthper) {
          errors.twelfthper = 'Required';
        }
        if (!values.backlogs) {
          errors.backlogs = 'Required';
        }
        if (!values.UGCGPA) {
          errors.UGCGPA = 'Required';
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {

  const data = JSON.parse(JSON.stringify(values, null, 2));
  console.log(data);
  company = data.companyname;
  CTC = data.salary;
  try {
    dataRetriever(data.tenthper,data.twelfthper,data.UGCGPA);
  }
  catch (err)
  {
    console.log(err);
  }
  setSubmitting(false);
  setTimeout(() => {navigate(`../eligibleStudents`);},3000)

}}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => (
        
        <form onSubmit={handleSubmit}> 
        <span className="personal-details" style={{marginBottom:'3%'}}>
        <Padding/>
        <Typography variant="h4" sx={{fontFamily:'Montserrat'}}>Eligible students form</Typography>
        <FormInput
            placeholder="Company Name"
            type="text"
            name="companyname"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.companyname}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.companyname && errors.companyname}</span>
        <FormInput
            placeholder="CTC/Company Package"
            type="number"
            name="salary"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.salary}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.salary && errors.salary}</span>  
        <FormInput  
            placeholder="10th %"
            type="number"
            name="tenthper"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.tenthper}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.tenthper && errors.tenthper}</span>
        <FormInput 
            placeholder="12th %"
            type="number"
            name="twelfthper"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.twelfthper}
          />
           <span style={{fontFamily : 'Montserrat'}}>{touched.twelfthper && errors.twelfthper}</span>
        </span>
          
        <span className="personal-details" style={{marginBottom:'1px'}}>
          <Padding/>
          <Padding/>
        <FormInput 
            placeholder="UG CGPA"
            type="number"
            name="UGCGPA"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.UGCGPA}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.UGCGPA && errors.UGCGPA}</span>
        <FormInput 
            placeholder="PG CGPA (if applicable)"
            type="number"
            name="PGCGPA"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.PGCGPA}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.PGCGPA && errors.PGCGPA}</span>
        <FormInput 
            placeholder="No. of backlogs"
            type="number"
            name="backlogs"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.backlogs}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.backlogs && errors.backlogs}</span>
        <FormInput 
            placeholder="Education Gap"
            type="number"
            name="educationgap"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.educationgap}
          />
          <span style={{fontFamily : 'Montserrat'}}>{touched.educationgap && errors.educationgap}</span>
        </span>
        <span className="personal-details">
          <Button type="submit" disabled={isSubmitting}>
            Next
          </Button>
        </span>
        </form>
      )}
    </Formik>
  </div>
  );
}

export default PersonalDetails;
export { finalList, CTC, company };
